import Link from "@components/Link";
import {
  ThemeContext,
  ThemeEnum,
} from "@components/ThemeProvider/ThemeProvider";
import clsx from "clsx";
import type { ReactElement } from "react";
import React, { useContext } from "react";

type NavigaterProps = {
  className?: string;
  navList: {
    name: string;
    path: string;
  }[];
};

export default function Navigater(props: NavigaterProps): ReactElement {
  const { navList, className } = props;
  const { theme } = useContext(ThemeContext);
  return (
    <section className="flex" data-testid="redants-navigater">
      {navList.map((item, index) => (
        <React.Fragment key={item.name}>
          <Link
            to={item.path}
            className={clsx(
              "flex text-nowrap rounded-[100px] px-[12px] py-[4px] text-button-1 lg:hover:bg-button-ghost",
              className,
              theme === ThemeEnum.dark
                ? "text-primary-on-dark hover:text-primary"
                : "text-primary",
            )}
            data-testid={`navigater-${item.name}`}
          >
            {item.name}
          </Link>

          {index !== navList.length - 1 && (
            <div className="flex items-center">
              <div className="m-[4px] size-[8px] rounded-full bg-[--icon-brand]" />
            </div>
          )}
        </React.Fragment>
      ))}
    </section>
  );
}
